const TONE = {
  primary: 'var(--text-primary)',
  secondary: 'var(--text-secondary)',
  tertiary: 'var(--text-tertiary)',
};

export default function Body({ tone = 'primary', as: Tag = 'p', children, style, ...rest }) {
  return (
    <Tag
      style={{
        fontFamily: 'var(--font-body)',
        fontWeight: 400,
        fontSize: 15,
        lineHeight: '22px',
        color: TONE[tone],
        ...style,
      }}
      {...rest}
    >
      {children}
    </Tag>
  );
}
